module.exports = __webpack_public_path__ + "media/images/riders/REECE_WILSON-836dae7a42359b79a89721704e11c8d2.png";